import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { Subscription } from 'rxjs'
import { OrganizationsService } from '../../services/organizations.service'
import { TranslateService } from '@ngx-translate/core'
import { ToastrService } from 'ngx-toastr'

@Component({
  selector: 'app-upload-gallary-images',
  templateUrl: './upload-gallary-images.component.html',
  styleUrls: ['./upload-gallary-images.component.scss']
})
export class UploadGallaryImagesComponent implements OnInit {
  accetpFiles = "image/png, image/jpeg, image/jpg"
  subscription = new Subscription

  uploudedImages: File[] = []
  renderdImages: any[] = []
  sizeError = false
  maxNumber = false
  body: any[] = []
  constructor(public dialog: MatDialogRef<UploadGallaryImagesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { branchId: number },
    private organizationsService: OrganizationsService,
    private toaster: ToastrService,
    private translate: TranslateService) { }

  ngOnInit(): void {
  }

  fileChangeEvent(event: any) {
    this.sizeError = false
    this.maxNumber = false
    if (event?.target?.files?.length + this.uploudedImages?.length < 6) {
      [...event?.target?.files].forEach((file: File) => {
        if (file?.size <= 1000000 && this.accetpFiles.includes(file?.type)) {
          this.uploudedImages.push(file)
        }
        else this.sizeError = true
      })
    } else this.maxNumber = true

    this.renderImage()

  }

  deleteImage(index: number) {
    this.uploudedImages.splice(index, 1)
    this.renderdImages.splice(index, 1)
    this.maxNumber = false
  }

  renderImage() {
    this.renderdImages = []
    this.uploudedImages.forEach(file => {
      const reader = new FileReader();
      reader.onload = (_event) => {
        this.renderdImages.push(reader.result);
      }
      reader.readAsDataURL(file);
    })
  }

  uploadImage(index: number) {
    const formData = new FormData()
    formData.append('image', this.uploudedImages[index])
    this.subscription.add(
      this.organizationsService.uploadGalleryImage(formData).subscribe((res: any) => {
        this.body.push({
          url: res?.result.url,
          "mediaType": 5,
          "thumbnailUrl": ""
        }
        )
        index < this.uploudedImages?.length-1 ?   this.uploadImage(index + 1) : this.updateGallery()
      })
    )
  }

  updateGallery() {
    const body = {
      "branchId": this.data.branchId,
      "items": [
        ...this.body
      ]
    }
    this.subscription.add(
      this.organizationsService.AddToGallery(body).subscribe(res => {
        this.dialog.close(true);
        this.toaster.success(this.translate.instant('TOASTER.MSG_SUCCESS'))
      })
    )
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
  }
}
